export interface WidgetInteraction {
    id: string;
    query: string;
    summary?: string;
    created_at: string;
    sql_query?: string;
    data_preview?: any[];
    visualization_type?: string;
}

export interface Widget {
    id: string;
    user_id: string;
    connection_id?: number;
    collection_id?: string;
    report_tab?: string;
    title: string;
    users_query: string;
    generated_sql_query: string;
    query_response: string;
    data?: any[]; // Optional - new API format for data
    last_data_snapshot?: any[]; // Optional - computed from query_response
    context_history: any[];
    visualization_type: string;
    created_at: string;
    updated_at: string;
    display_order?: number;
    // Frontend-only state for chat history
    interactions?: WidgetInteraction[];
}

// Utility function to get parsed data from widget
export const getWidgetData = (widget: Widget): any[] => {
    if (widget.last_data_snapshot) {
        return widget.last_data_snapshot;
    }
    
    // Check if widget has a 'data' field (new API format)
    if ((widget as any).data && Array.isArray((widget as any).data)) {
        return (widget as any).data;
    }
    
    // Fallback to parse query_response if it's a JSON string (old format)
    try {
        const parsed = JSON.parse(widget.query_response);
        return Array.isArray(parsed) ? parsed : [parsed];
    } catch (error) {
        console.warn('Failed to parse widget query_response:', error);
        return [];
    }
};

export interface WidgetCreate {
    user_id: string;
    connection_id: number;
    collection_id: string;
    title: string;
    users_query: string;
    generated_sql_query: string;
    query_response: string;
    last_data_snapshot?: any[];
    context_history?: any[];
    visualization_type: string;
}

export interface WidgetUpdate {
    title?: string;
    is_deleted?: boolean;
    display_order?: number;
}

export interface WidgetOrderUpdate {
    user_id: string;
    collection_id?: string;
    widget_orders: {
        widget_id: string;
        display_order: number;
    }[];
}
